import cn from 'classnames';

import { IConDefaultType } from '../types';

interface INarrationIconProps extends IConDefaultType {}

function NarrationIcon({ className, size = 24, rotate, flip }: INarrationIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7284 2.97527C21.3833 2.57272 20.7773 2.5261 20.3747 2.87115C19.9722 3.21619 19.9256 3.82224 20.2706 4.22479C21.2347 5.34961 22.3266 8.27871 20.2007 11.4675C19.9066 11.9087 20.0258 12.5047 20.467 12.7988C20.9081 13.0929 21.5042 12.9737 21.7983 12.5325C24.4724 8.52136 23.1642 4.65045 21.7284 2.97527ZM10.1281 12.0006C12.3372 12.0006 14.1281 10.2097 14.1281 8.00056C14.1281 5.79142 12.3372 4.00056 10.1281 4.00056C7.91892 4.00056 6.12806 5.79142 6.12806 8.00056C6.12806 10.2097 7.91892 12.0006 10.1281 12.0006ZM1.24698 19.3605C2.272 15.8963 5.93401 13.3333 10.2944 13.3333C14.6548 13.3333 18.3168 15.8963 19.3418 19.3605C19.6552 20.4197 18.7323 21.3333 17.6277 21.3333H2.96105C1.85649 21.3333 0.933591 20.4197 1.24698 19.3605ZM17.5703 4.54157C18.0445 4.30447 18.6211 4.49668 18.8582 4.9709L18.8793 5.01305C19.169 5.59199 19.5371 6.32761 19.6298 7.2547C19.7272 8.22834 19.5176 9.31089 18.8582 10.6295C18.6211 11.1038 18.0445 11.296 17.5703 11.0589C17.0961 10.8218 16.9038 10.2451 17.1409 9.7709C17.6816 8.68956 17.772 7.97211 17.7194 7.44575C17.6643 6.89549 17.4483 6.44429 17.1409 5.82955C16.9038 5.35533 17.0961 4.77868 17.5703 4.54157Z"
          fill="#00C3DD"
        />
      </svg>
    </i>
  );
}

export default NarrationIcon;
